import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Page imports
import HomePage from "./pages/HomePage";
import LearnPage from "./pages/LearnPage";
import ArticlePage from "./pages/ArticlePage";
import VideoLibrary from "./pages/VideoLibrary";
import AfterVisitPage from "./pages/AfterVisitPage";
import AfterVisitDetailPage from "./pages/AfterVisitDetailPage";
import AdminAccess from "./pages/AdminAccess";
import EducationLibrary from "./pages/EducationLibrary";
import EducationalTopicPage from "./pages/EducationalTopicPage";
import CommonConcernArticle, { CommonConcernsIndex } from "./pages/CommonConcernArticle";
import CancerArticle, { CancerIndex } from "./pages/CancerArticle";
import StandaloneArticle, { StandaloneArticlesIndex } from "./pages/StandaloneArticle";
import UrologicInstruments from "./pages/UrologicInstruments";

// New Hub Pages
import ConditionsPage from "./pages/ConditionsPage";
import ProceduresPage from "./pages/ProceduresPage";
import CancersPage from "./pages/CancersPage";

// Legal pages
import DisclaimerPage from "./pages/DisclaimerPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import ContactPage from "./pages/ContactPage";

// Anatomy pages
import AnatomyPage, { AnatomyIndexPage } from "./pages/AnatomyPage";

// Symptoms pages
import SymptomPage, { SymptomsIndexPage } from "./pages/SymptomPage";

// Tests pages
import TestPage, { TestsIndexPage } from "./pages/TestPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Main pages */}
          <Route path="/" element={<HomePage />} />
          
          {/* NEW: Six Hub Structure */}
          {/* 1. Symptoms Hub */}
          <Route path="/symptoms" element={<SymptomsIndexPage />} />
          <Route path="/symptoms/:symptomId" element={<SymptomPage />} />
          
          {/* 2. Conditions Hub */}
          <Route path="/conditions" element={<ConditionsPage />} />
          <Route path="/conditions/:articleId" element={<ArticlePage />} />
          
          {/* 3. Procedures Hub */}
          <Route path="/procedures" element={<ProceduresPage />} />
          <Route path="/procedures/:articleId" element={<ArticlePage />} />
          
          {/* 4. Tests Hub */}
          <Route path="/tests" element={<TestsIndexPage />} />
          <Route path="/tests/:testId" element={<TestPage />} />
          
          {/* 5. Cancers Hub */}
          <Route path="/cancers" element={<CancersPage />} />
          <Route path="/cancers/:articleId" element={<ArticlePage />} />
          
          {/* 6. After Visit Hub */}
          <Route path="/after-visit" element={<AfterVisitPage />} />
          <Route path="/after-visit/:instructionId" element={<AfterVisitDetailPage />} />
          
          {/* Legacy routes - redirect to new structure */}
          <Route path="/learn" element={<Navigate to="/conditions" replace />} />
          <Route path="/learn/:articleId" element={<ArticlePage />} />
          <Route path="/education" element={<Navigate to="/conditions" replace />} />
          <Route path="/education/urologic-instruments" element={<UrologicInstruments />} />
          <Route path="/education/:topicId" element={<EducationalTopicPage />} />
          
          {/* Videos - accessible but not in main nav */}
          <Route path="/videos" element={<VideoLibrary />} />
          
          {/* Admin */}
          <Route path="/admin-access" element={<AdminAccess />} />
          
          {/* Common Concerns - legacy */}
          <Route path="/common-concerns" element={<CommonConcernsIndex />} />
          <Route path="/common-concerns/:articleId" element={<CommonConcernArticle />} />
          
          {/* Old Cancer routes - redirect to new */}
          <Route path="/cancer" element={<Navigate to="/cancers" replace />} />
          <Route path="/cancer/:cancerId" element={<CancerArticle />} />
          
          {/* Standalone Articles */}
          <Route path="/articles" element={<StandaloneArticlesIndex />} />
          <Route path="/articles/:articleId" element={<StandaloneArticle />} />
          
          {/* Anatomy pages */}
          <Route path="/anatomy" element={<AnatomyIndexPage />} />
          <Route path="/anatomy/:organId" element={<AnatomyPage />} />
          
          {/* Legal pages */}
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/contact" element={<ContactPage />} />
          
          {/* Redirects for old routes */}
          <Route path="/article/:articleId" element={<ArticlePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
